import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-bootstrap-modal'
import { postForm, patchForm } from '../../ajax'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import _ from 'lodash'

const AdminForm = ({sdAdmin, onClose, onError, onCreate, onUpdate}) => {
  useEffect(() => {
    if (sdAdmin) reset(_.omit(sdAdmin, 'id', 'created_at', 'updated_at'))
  }, [sdAdmin])

  const schema = yup.object({
    current_password: sdAdmin && yup.string().trim().required('Required field').nullable(),
    first_name: yup.string().trim().required('Required field')
      .max(100, 'Line is too long').nullable(),
    last_name: yup.string().trim().required('Required field')
      .max(100, 'Line is too long').nullable(),
    email: yup.string().required('Required field')
      .email('Wrong format')
      .max(100, 'Line is too long').nullable(),
    password: yup.string().trim().required('Required field')
      .max(40, 'Line is too long').nullable(),
    password_confirmation: yup.string().trim().required('Required field')
      .oneOf([yup.ref('password'), null], 'Passwords not match')
      .max(40, 'Line is too long').nullable()
  })

  const { register, reset, getValues, setValue, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  })

  const prepareFormData = data => {
    let formData = new FormData()
    for (const key in data) formData.append(`sd_admin[${key}]`, data[key])
    return formData
  }

  const onSubmit = data => {
    const formMethod = sdAdmin ? patchForm : postForm
    const submitUrl = sdAdmin ? `/admins/sd_admins/${sdAdmin.id}` : '/admins/sd_admins'
    const formData = prepareFormData(data)

    formMethod(submitUrl, formData)
    .then(response => { return response.json() })
    .then((json) => {
      if (json.error) return onError(json.error)
      sdAdmin ? onUpdate(json.sd_admin) : onCreate(json.sd_admin)
    })
  }

  return (
    <Modal container={document.body} show={true} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Admin</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <form className='form form-horizontal' onSubmit={handleSubmit(onSubmit)}>
            { sdAdmin &&
              <div className='form-group'>
                <label className='control-label col-lg-2' htmlFor='current_password'>Current Password</label>
                <div className='col-lg-10'>
                  <input
                    {...register('current_password')}
                    id='current_password'
                    className='form-control'
                    type='text'
                  />
                  { errors && errors.current_password && <span className='error'>{errors.current_password.message}</span> }
                </div>
              </div>
            }
            <div className='form-group'>
              <label className='control-label col-lg-2' htmlFor='first_name'>First Name</label>
              <div className='col-lg-10'>
                <input
                  {...register('first_name')}
                  id='first_name'
                  className='form-control'
                  type='text'
                />
                { errors && errors.first_name && <span className='error'>{errors.first_name.message}</span> }
              </div>
            </div>
            <div className='form-group'>
              <label className='control-label col-lg-2' htmlFor='last_name'>Last Name</label>
              <div className='col-lg-10'>
                <input
                  {...register('last_name')}
                  id='last_name'
                  className='form-control'
                  type='text'
                />
                { errors && errors.last_name && <span className='error'>{errors.last_name.message}</span> }
              </div>
            </div>
            <div className='form-group'>
              <label className='control-label col-lg-2' htmlFor='email'>Email</label>
              <div className='col-lg-10'>
                <input
                  {...register('email')}
                  id='email'
                  className='form-control'
                  type='text'
                />
                { errors && errors.email && <span className='error'>{errors.email.message}</span> }
              </div>
            </div>
            <div className='form-group'>
              <label className='control-label col-lg-2' htmlFor='password'>Password</label>
              <div className='col-lg-10'>
                <input
                  {...register('password')}
                  id='password'
                  className='form-control'
                  type='text'
                />
                { errors && errors.password && <span className='error'>{errors.password.message}</span> }
              </div>
            </div>
            <div className='form-group'>
              <label className='control-label col-lg-2' htmlFor='password_confirmation'>Password Confirmation</label>
              <div className='col-lg-10'>
                <input
                  {...register('password_confirmation')}
                  id='password_confirmation'
                  className='form-control'
                  type='text'
                />
                { errors && errors.password_confirmation && <span className='error'>{errors.password_confirmation.message}</span> }
              </div>
            </div>
            <div className='form-group'>
              <div className='col-lg-offset-2 col-lg-10'>
                <input type='submit' value='Save' className='btn btn-primary' />
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AdminForm
